export const getUdReassignment = (originalData) =>
  originalData?.udReassignment;

export const isUdReassignmentEnabled = (meta) => meta?.enabled === true;

export const isEligibleUdDrivingEntry = (entry, meta) => {
  if (!entry || !isUdReassignmentEnabled(meta)) return false;
  if (Array.isArray(meta?.eligibleEventIds)) {
    const eventIdStr = entry.eventId != null ? String(entry.eventId) : '';
    const idStr = entry.id != null ? String(entry.id) : '';
    return meta.eligibleEventIds.some(
      (id) => String(id) === eventIdStr || String(id) === idStr
    );
  }
  return entry?.status === 'DRIVING';
};

export const hasActiveUdReassignmentRequests = (meta) => meta?.activeRequests?.length > 0;

export const isWholeLogEditBlockedByUd = (meta) => {
  if (!meta) return false;
  if (meta.canEditWholeLog === false) return true;
  if (meta.activeRequests?.length > 0) return true;
  return false;
};

const normalizeDriverId = (driverId) => {
  if (driverId == null || driverId === '') return null;
  if (typeof driverId === 'object') return String(driverId.value ?? driverId);
  return String(driverId);
};

export const getCurrentDriverLabel = (entry, companyDrivers = {}) => {
  const driverId = normalizeDriverId(entry?.driverId);
  if (!driverId) return '-';
  return companyDrivers[driverId] || entry?.driverFullName || driverId;
};
